import { render, staticRenderFns } from "./lostArticle.vue?vue&type=template&id=7caebaae&"
import script from "./lostArticle.vue?vue&type=script&lang=js&"
export * from "./lostArticle.vue?vue&type=script&lang=js&"
import style0 from "./lostArticle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports